import { useContext } from "react"

import { tableContext } from "../utils"

export function useClick() {
  const { onRowClick, onCellClick } = useContext(tableContext)

  return { onRowClick, onCellClick }
}
